export default __webpack_public_path__ + "i18n/translations/translation-hi.7520ef40.json";